export default "__VITE_ASSET__DWc4OIGT__"